<template>
  <div class="web-main">
    <Nav />
    <div class="body-container">
      <div class="contenedor-body" style="padding: 14px">
        <router-view />
      </div>
    </div>
    <!-- <Footer /> -->
  </div>
</template>

<script>
import Nav from "./nav.vue";
export default {
  components: {
    Nav,
  },
  mounted() {
    console.log("cargando home");
  },
};
</script>

<style lang="scss" scoped>
@media (max-width: 768px) {
  .web-main {
    text-align: left;
  }
}
@media (min-width: 768px) {
  .web-main {
    text-align: left;
  }
}

@media(min-width: 1500px) {
  .web-main {
    padding-inline: 200px;
  }
}
</style>
